// Utility
export const lastDotInStringRegExp = /\.(?=[^.]+$)/;

// Image API's
export const unsplashImageApiRegExp = /^https:\/\/images\.unsplash\.com/;
export const zyroImageApiRegExp = /^https:\/\/assets\.zyrosite\.com/;
export const zyroImageApiDevelopmentRegExp = /^http:\/\/zrassets\.s3-website\.eu-north-1\.amazonaws\.com\/00-images/;
